import { render, staticRenderFns } from "./ChengShu_taskmana.vue?vue&type=template&id=66b6a7b6&scoped=true"
import script from "./ChengShu_taskmana.vue?vue&type=script&lang=js"
export * from "./ChengShu_taskmana.vue?vue&type=script&lang=js"
import style0 from "./ChengShu_taskmana.vue?vue&type=style&index=0&id=66b6a7b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b6a7b6",
  null
  
)

export default component.exports